export default __webpack_public_path__ + "static/media/john.8a892007.webp";